import { Component, HostListener, OnInit } from '@angular/core';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs/index';

export const createAlertModalOptions = (title: string, message: string): ModalOptions => ({
    initialState: {
        title,
        message
    },
    backdrop: 'static'
});

@Component({
    selector: 'modal-alert',
    template: `
    <div class="modal-header">
      <button type="button" class="close" (click)="bsModalRef.hide()">&times;</button>
      <h4 class="modal-title">{{ title || 'Alert' }}</h4>
    </div>
    <div class="modal-body">
      <p>{{ message || '!' }}</p>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-primary" (click)="onConfirm()">{{ okLabel || 'OK' }}</button>
    </div>
  `
})

export class BsModalAlertComponent implements OnInit {

    // These fields will be set if provided in initialState

    title: string;
    message: string;
    okLabel: string;

    public onClose: Subject<boolean>;

    constructor(public bsModalRef: BsModalRef) {}

    public ngOnInit(): void {
        this.onClose = new Subject();
    }

    public onConfirm(): void {
        this.onClose.next(true);
        this.bsModalRef.hide();
    }

    @HostListener('document:keypress', ['$event'])
    keyEvent(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.onConfirm();
        }
    }
}
